import ThemedPrice, { propTypes } from './ThemedPrice';

export default ThemedPrice;
export { propTypes };
